import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function CommentsIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17.75 17.39"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.secondary00, ...props.style }}
    >
      <g>
        <path d="M.9,17.25c-.08,0-.16-.01-.24-.04-.31-.1-.53-.4-.53-.73V.87C.14.44.48.1.9.1h15.89c.42,0,.76.35.76.77v11.84c0,.42-.34.77-.76.77H4.08l-2.57,3.46c-.15.2-.37.31-.61.31ZM1.14,1.1v14.66l2.21-2.98c.14-.19.37-.31.61-.31h12.6V1.1H1.14Z" />
        <path d="M13.59,5.18H4.16c-.23,0-.42-.22-.42-.5s.19-.5.42-.5h9.43c.23,0,.42.22.42.5s-.19.5-.42.5Z" />
        <path d="M9.97,9.45h-5.81c-.23,0-.42-.22-.42-.5s.19-.5.42-.5h5.81c.23,0,.42.22.42.5s-.19.5-.42.5Z" />
      </g>
    </SvgIcon>
  );
}
